import './Textbox.scss';

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Label from 'components/Label';
import FormValidationMessage from 'components/FormValidationMessage';

export default class Textbox extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        disabled: PropTypes.bool,
        id: PropTypes.string,
        label: PropTypes.string,
        name: PropTypes.string.isRequired,
        onChange: PropTypes.func,
        placeholder: PropTypes.string,
        type: PropTypes.string.isRequired,
        validation: PropTypes.object,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    };

    render() {
        let { label, type, validation, ...otherProps } = this.props;

        let classes = classNames(
            'o-textbox',
            this.props.className,
            {
                'has-error': validation != null && validation.show === true && validation.isValid === false,
                'a-textbox--disabled': this.props.disabled === true
            }
        );

        return (
            <div className={classes}>
                {label != null ? (
                    <Label htmlFor={this.props.id}>{label}</Label>
                ) : null}

                {type === 'textarea' ? (
                    <textarea
                        {...otherProps}
                        className="c-textbox c-textarea"
                        rows="5"
                    />
                ) : (
                    <input
                        {...otherProps}
                        className="c-textbox"
                        type={type || 'text'}
                    />
                )}

                {validation && validation.show && <FormValidationMessage>{validation.error.reason}</FormValidationMessage>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Textbox/index.js